import { PermanentFilterStorage } from './permanent-filter-storage';
import type { FilterObject, FilterStorageOptions } from './types';

export class QuickFilterPermanentStorage {
  permanentFilterStorage: PermanentFilterStorage;

  constructor(options: FilterStorageOptions = {}) {
    const {
      featureName,
      entityName,
      preferenceService,
    } = options;

    this.permanentFilterStorage = new PermanentFilterStorage({
      featureName,
      preferenceService,
      storageKey: this.getStorageKey({
        featureName,
        entityName,
      }),
    });
  }

  /**
   * @private
   * @return {String} - resource and entry ids
   */
  getStorageKey({
    featureName,
    entityName,
  }: { featureName?: string; entityName?: string }) {
    return `quick-filter-storage-campaignwebui-${featureName}-${entityName}/QuickFilter`;
  }

  /**
   * @returns {Object} Promise that resolve to Filter object that contains query,
   * name and id
  */
  get() {
    return this.permanentFilterStorage.get();
  }

  /**
   * Save quick filter key and query to session
   * @param {string} key - Filter key
   * @param {Object} value - Filter query object
   * @return {undefined}
   */
  save(key: string, value: FilterObject) {
    return this.permanentFilterStorage.save({
      key,
      value,
    });
  }

  clean() {
    return this.permanentFilterStorage.delete();
  }
}
